"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var hooks_1 = require("utils/hooks");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var rechReconciliation_1 = require("utils/setectOptions/rechReconciliation");
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var AccountCodesDropdown = function (_a) {
    var setStep = _a.setStep;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var reconciliation = rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.reconciliation;
    var _b = __read((0, hooks_1.useSubmitter)('recharger_companies', company === null || company === void 0 ? void 0 : company.id), 2), submitCompany = _b[0], isSending = _b[1];
    var xeroAccounts = (0, react_redux_1.useSelector)(ordered_1.selectXeroAccountsForRevenue);
    var selectedCode = {
        value: reconciliation === null || reconciliation === void 0 ? void 0 : reconciliation.rechargesAccountingAccountId,
        label: (0, rechReconciliation_1.getXeroAccountDescription)(xeroAccounts === null || xeroAccounts === void 0 ? void 0 : xeroAccounts.find(function (xA) { return xA.AccountID === (reconciliation === null || reconciliation === void 0 ? void 0 : reconciliation.rechargesAccountingAccountId); })),
    };
    var handleChange = function (valObj) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(valObj && 'value' in valObj && (valObj === null || valObj === void 0 ? void 0 : valObj.value))) return [3 /*break*/, 2];
                    return [4 /*yield*/, submitCompany({ reconciliation: { rechargesAccountingAccountId: valObj.value } }).then(function () { return setStep === null || setStep === void 0 ? void 0 : setStep(); })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, valObj];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row", alignItems: "center", height: 40, spacing: 1 }, { children: [!(0, react_redux_firebase_1.isLoaded)(xeroAccounts) && (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {}), (0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { isDisabled: isSending, label: "Select code", options: xeroAccounts === null || xeroAccounts === void 0 ? void 0 : xeroAccounts.map(rechReconciliation_1.makeCodeOptions), value: selectedCode, placeholder: "Select code", onChange: handleChange, btnProps: { className: 'highlightInput', withCaret: true } })] })));
};
exports.default = AccountCodesDropdown;
